<script>
	import Nav from "./components/Nav.svelte"
	import { onMount } from "svelte";
	import { Accordion, AccordionItem } from "carbon-components-svelte";
	//import thougthsTasks from './store'; 
	import { user,refreshTasks,thougthsTasks,scheduledTasks,nextTasks,delegatedTasks,somedayTasks } from "./store";
	import {Projectsvc} from "./services/project";
	import {Topicsvc} from "./services/topic";
	import {Contextsvc} from "./services/context";
	import ThoughtCards from "./components/ThoughtCards.svelte";
	import ThoughtTable from "./components/ThoughtTable.svelte";
	import DelegateTable from "./components/DelegateTable.svelte";
	import ScheduledTable from "./components/ScheduledTable.svelte";
	import ProjectList from "./components/ProjectList.svelte";
	import TopicList from "./components/TopicList.svelte";
	import ContextList from "./components/ContextList.svelte";
	import GoogleLogin from "./components/GoogleLogin.svelte";
	//$: completedTodos = todos.filter(todo => todo.completed).length
	//$: delegatedTasks = tasks.filter((item) => item.getStatus() == 0);

	let page;

	onMount(() => {
		user.useLocalStorage();
		console.log("Retrieved User from localStorage", $user);
	})

	//Doesn't work
	$: if ($user.logged_in === true) {
		console.log("Retrieving User tasks", $user.name);
		refreshTasks()
		let projectsvc = new Projectsvc();
		let topicsvc = new Topicsvc();
		let contextsvc = new Contextsvc();
		} else {console.log("User not logged in", user)}

	let sleep = ms => new Promise(r => setTimeout(r, ms));


	function handleLogout() {
	  user.set({logged_in: false});
	  logged_in = false;
	}
	async function handleLogin(e) {
		console.dir(e.detail.user)
		let tmpuser = {};
		tmpuser.name = e.detail.user.Du.tf
		tmpuser.id = e.detail.user.Ba
		tmpuser.accessToken = e.detail.user.wc.id_token
		tmpuser.logged_in = true;
		user.set(tmpuser)
		page = "inbox";
		//Wait for access token to be updated before continuing.
	}
	console.log("API: " +  VITE_APIURL)
  </script>
    <Nav bind:page={page}>
	  <span slot="content">
		{#if page == "inbox"}
		 <ThoughtCards tasks={$thougthsTasks}/>
		{:else if page =="next"}
		<ThoughtTable tasks={$nextTasks}/>
		{:else if page =="active"}
		<ThoughtTable tasks={$nextTasks}/>
		{:else if page =="delegated"}
		<DelegateTable tasks={$delegatedTasks}/>
		{:else if page =="scheduled"}
		<ScheduledTable tasks={$scheduledTasks}/>
		{:else if page =="completed"}
		<ThoughtTable tasks={$nextTasks}/>
		{:else if page =="someday"}
		<ThoughtTable tasks={$somedayTasks}/>
		{:else if page =="projects-active"}
		<ProjectList/>
		{:else if page =="context"}
		<ContextList/>
		{:else if page =="topics"}
		<TopicList/>				
		{:else if page == "Accordion"}
		<Accordion>
			<AccordionItem title="Thoughts" open>
		<h3>Thoughts</h3>
		<ThoughtCards tasks={$thougthsTasks}/>
		</AccordionItem>
		<AccordionItem title="Next">
		<h3>Next</h3>
		<ThoughtCards tasks={$nextTasks}/>
		</AccordionItem>
		<AccordionItem title="Delegated">
		<h3>Delegated</h3>
		<ThoughtTable tasks={$delegatedTasks}/>
		</AccordionItem>
		
		<AccordionItem title="Scheduled">
		<h3>Scheduled</h3>
		<ThoughtTable tasks={$scheduledTasks}/>
		</AccordionItem>
		<AccordionItem title="Completed">
		<h3>Completed</h3>
		<ThoughtCards tasks={$thougthsTasks}/>
		</AccordionItem>
		</Accordion>
		{:else}
		<!-- <GoogleAuth text="Login with Google" clientId="684541831384-g15hjhaf3ul7fin1mbg1c011sbuddakg.apps.googleusercontent.com" on:auth-success={e => handleLogin(e)} /> -->
			<div>I'm here</div>	<!-- 			<div id="g_id_onload"
     data-client_id="684541831384-g15hjhaf3ul7fin1mbg1c011sbuddakg.apps.googleusercontent.com"
     data-context="signin"
     data-callback={(e) => console.log(e)}
     data-auto_select="true"> -->
	

		{/if}
		  </span>
  </Nav>
  
  <main>
	  <div>
{#if $user.logged_in}
<h3>Welcome {$user.name}</h3>
		<button on:click={handleLogout}>Logout</button>
{:else}
<div>
	<GoogleLogin />
</div>
{/if}




  

	


</div>
	</main>
